module.exports = __webpack_public_path__ + "static/media/football.416555b2.jpg";